import React, { useState } from 'react'
import { IoBagOutline, IoMenu } from 'react-icons/io5'
import { RxCross2 } from 'react-icons/rx'
import { Link } from 'gatsby'
import { CiFacebook, CiInstagram } from 'react-icons/ci'
import { language } from '../../types'
import { localizedPath, localize } from '../../utils/language'
import { trackTakeoutOrderClick } from '../TakeoutOrderButton'

const languages: { code: language; label: string; flag: string }[] = [
  { code: 'JA', label: '日本語', flag: 'fi fi-jp' },
  { code: 'EN', label: 'English', flag: 'fi fi-us' },
  { code: 'ZH', label: '中文', flag: 'fi fi-cn' },
  { code: 'TW', label: '繁體中文', flag: 'fi fi-tw' },
  { code: 'KO', label: '한국어', flag: 'fi fi-kr' },
]

const MobileMenu = (
  {
    isRoot,
    isScrolled,
    headers,
    lang,
    changeLangLink,
    showFlags,
  }
    :
    {
      isRoot: boolean,
      isScrolled: boolean,
      headers: any[],
      lang: language,
      changeLangLink: (toLang: language) => string,
      showFlags: boolean
    }) => {

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div
        className={`right-0 top-0 fixed h-screen w-72 bg-henkotsu z-50 lg:hidden transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
      >
        <button
          type='button'
          onClick={() => setIsOpen(false)}
          aria-label='メニューを閉じる'
          className='ml-auto m-4 p-2'
        >
          <RxCross2 className='text-3xl cursor-pointer' />
        </button>
        <ul className='mt-20 ml-16 flex flex-col gap-6 text-lg md:mt-16'>
          {headers.map(i => <li key={localize(i.title, lang)}>
            {i.external ? (
              <a
                href={i.link}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                  trackTakeoutOrderClick('header', i.link)
                  setIsOpen(false)
                }}
              >
                {localize(i.title, lang)}
              </a>
            ) : (
              <Link
                to={localizedPath(lang, i.link)}
                onClick={() => setIsOpen(false)}
              >
                {localize(i.title, lang)}
              </Link>
            )}
          </li>)}
          {lang === 'JA' && <li><Link
            to='/careers/'
            onClick={() => setIsOpen(false)}
          >
            採用情報
          </Link></li>}
        </ul>
        <button
          type='button'
          className='ml-12 mt-12 w-48 py-2 flex items-center justify-center gap-2 text-primary-500 border rounded border-primary-500 md:mt-16 invisible'
        >
          テイクアウト <IoBagOutline className='text-3xl mb-1' />
        </button>
        {showFlags && (
          <div className='ml-16 flex flex-col gap-3'>
            {languages.map(item => <Link
              key={item.code}
              to={changeLangLink(item.code)}
              onClick={() => setIsOpen(false)}
              aria-current={lang === item.code ? 'page' : undefined}
              className={`flex items-center gap-2 transition-opacity ${lang === item.code ? 'font-semibold' : 'opacity-60'}`}
            >
              <span className={`${item.flag} text-xl ${item.code === 'JA' ? 'border border-black border-[0.5px]' : ''}`} />
              <span>{item.label}</span>
            </Link>)}
          </div>
        )}

        <div className='flex ml-16 gap-4 mt-6 text-4xl text-primary-500'>
          <a
            href='https://www.instagram.com/henkotsu_udon/'
            aria-label='Instagram of henkotu'
          >
            <CiInstagram />
          </a>
          <a
            href='https://www.facebook.com/HenkotsuUdon/?locale=ja_JP'
            aria-label='facebook of henkotu'
          >
            <CiFacebook />
          </a>
        </div>
      </div>
      <IoMenu
        onClick={() => setIsOpen(true)}
        className={`text-4xl cursor-pointer lg:hidden ${isRoot && !isScrolled ? 'text-white' : ''}`}
      />
    </>
  )
}

export default MobileMenu
